import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { api } from 'lib/axios';
import { ListingError, ListingRequest, ListingResponse } from './types';

export const useListing = () => {
  const { isError, isLoading, data, mutateAsync, error } = useMutation<
    ListingResponse,
    AxiosError<ListingError>,
    ListingRequest,
    ListingResponse
  >((args) =>
    api
      .post(
        '/add-listing-price',
        {
          list_price: args.list_price,
          transBrokerComp: args.transBrokerComp,
          address: args.address,
        },
        {
          headers: {
            Authorization: `Bearer ${args.jwt}`,
          },
        }
      )
      .then((res) => res.data)
  );

  return {
    sendListing: mutateAsync,
    isError,
    isLoading,
    data,
    error,
  };
};
